export default __webpack_public_path__ + "assets/sounds/c9f6bff849a1e9979e33d15843efb453.mp3";